//
// locale_eo.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/eo.json';
import localeData from "react-intl/locale-data/eo.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});



// WEBPACK FOOTER //
// ./tmp/packs/locale_eo.js